module.exports = __webpack_public_path__ + "e7a8e993fd41292f5181f024a684319e.svg";